// extracted by mini-css-extract-plugin
export default {"root":"style_root__s8gQH","arrow":"style_arrow__kv-0m"};